import { type LocationGroup, type LocationMethod, OrderType, type PriceInfo } from '../types'
import { useWindow } from './use-window'

/**
 * 返回imprint/blank支持情况
 * @param orderType
 * @returns 1：只支持imprint 2：只支持blank 3:imprint和blank都支持
 */
export const getBlankLimitation = (orderType: OrderType): number => {
  if (orderType === OrderType.SpecSample) {
    return 1
  }

  let blank = false
  let imprint = false
  const { priceList } = useWindow()

  priceList.forEach((f: any) => {
    if (f.BlankLimitation === 2) {
      blank = true
    } else if (f.BlankLimitation === 1) {
      imprint = true
    } else {
      blank = true
      imprint = true
    }
  })
  return (blank ? 2 : 0) + (imprint ? 1 : 0)
}
/**
 * 获取最大颜色个数
 * @param {any} priceList
 */
export const getImprintMaxColors = (priceList: PriceInfo[]) => {
  let maxColors = 0
  for (let i = 0; i < priceList.length; i++) {
    const p = priceList[i]
    if (p.MaxColors === 0) return 999
    maxColors = Math.max(maxColors, p.MaxColors)
  }
  return maxColors === 0 ? 999 : maxColors
}
/**
 * 返回所有的imprint methods
 * @returns
 */
export function getAllImprintMethods (): LocationMethod[] {
  const productData = (window as any).productData
  const { ImprintMedthodList } = productData

  const allImprintMethods: LocationMethod[] = []
  ImprintMedthodList.forEach((item: LocationGroup) => {
    item.Methods.forEach((m) => {
      allImprintMethods.push(m)
    })
  })
  return allImprintMethods
}

/**
 * 从price list里获取imprint method数据
 * @param priceList
 * @returns
 */
export function getImprintMethodByPriceList (
  priceList: PriceInfo[]
): LocationMethod[] {
  const imprintMethods: LocationMethod[] = []

  const all = getAllImprintMethods()

  for (let i = 0; i < priceList.length; i++) {
    if (priceList[i].ImprintMethodLimitation.length === 0) {
      return getAllImprintMethods()
    }

    imprintMethods.push(
      ...all.filter((f) =>
        priceList[i].ImprintMethodLimitation.includes(f.Method)
      )
    )
  }
  return imprintMethods
}

export const getDefaultLocation = (
  locarionGroups: LocationGroup[]
): LocationGroup | undefined => {
  const avlivate = locarionGroups.filter((f) => f.Enabled);
  
  if (avlivate.length > 0) {
    return avlivate[0]
  }
}

export const getDefaultMethod = (
  location: LocationGroup | undefined
): LocationMethod | undefined => {
  if (!location) {
    return
  }
  const avlivate = location.Methods.filter((f) => f.Enabled)
  if (avlivate.length > 0) {
    return avlivate[0]
  }
}

/**
 * 从imprintMethodMap里获取mapped后的method
 * @param method 原始method
 * @returns
 */
export const getMappedMethod = (method: string): string => {
  const methodMap = useWindow().imprintMethodMap
  return methodMap.get(method) || method
}
